// ATTENTION some debug information
import { ENVS_CONFIG } from './constants';
import { Logger } from '@/logger/index';

if (ENVS_CONFIG.REACT_APP_ENVIRONMENT !== 'PROD') {
  Logger(['[ENVS]', ENVS_CONFIG], 'debug', true);
}
